(function () {
  function initModelInfo() {
    const gallery = document.querySelector('product-gallery');
    if (!gallery) return;

    const dataEl = document.getElementById('model-info-data--unified');
    if (!dataEl) return;

    const contexts = ['youth', 'teen', 'women', 'men'];
    const firstImageFound = {};

    const urlCtx = new URLSearchParams(window.location.search).get('age_context') || 'all';

    const mediaItems = gallery.querySelectorAll('.product-gallery__media');

    mediaItems.forEach((item) => {
      const img = item.querySelector('img');
      if (!img) return;

      const rawAlt = (img.getAttribute('alt') || '').toLowerCase();
      const altTags = rawAlt.split(',').map((t) => t.trim());
      const normalizedTags = altTags.map((t) => (t === 'kids' ? 'youth' : t));

      contexts.forEach((ctx) => {
        if (firstImageFound[ctx]) return;
        if (!normalizedTags.includes(ctx)) return;

        const sourceDiv = dataEl.querySelector(`[data-model-info-context="${ctx}"]`);
        const metaContent = sourceDiv?.innerHTML?.trim();
        if (!metaContent) return;

        firstImageFound[ctx] = true;

        if (urlCtx !== 'all' && urlCtx !== ctx) return;

        item.style.position = 'relative';
        item.style.overflow = 'hidden';

        // Panel — full width, slides up from bottom of image
        const panel = document.createElement('div');
        panel.className = 'model-info-panel';
        panel.setAttribute('aria-hidden', 'true');
        panel.dataset.modelInfoContext = ctx;
        panel.innerHTML = metaContent;
        panel.style.cssText = `
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(255,255,255,0.97);
          color: #000;
          padding: 16px 20px;
          box-sizing: border-box;
          font-size: 13px;
          font-family: inherit;
          line-height: 1.6;
          transform: translateY(100%);
          transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 9;
        `;

        // Button — sits at bottom-left, rises with the panel
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'model-info-btn';
        btn.setAttribute('aria-expanded', 'false');
        btn.dataset.modelInfoContext = ctx;
        btn.textContent = 'Model Info';
        btn.style.cssText = `
          position: absolute;
          bottom: 20px;
          left: 20px;
          z-index: 10;
          background: #fff;
          color: #000;
          border: 1px solid rgba(0,0,0,0.15);
          border-radius: 999px;
          padding: 8px 16px;
          font-size: 13px;
          font-family: inherit;
          cursor: pointer;
          line-height: 1;
          white-space: nowrap;
          box-shadow: 0 1px 4px rgba(0,0,0,0.12);
          width: fit-content;
          transition: bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        `;

        btn.addEventListener('click', () => {
          const isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
            panel.style.transform = 'translateY(100%)';
            btn.style.bottom = '20px';
          } else {
            btn.setAttribute('aria-expanded', 'true');
            panel.setAttribute('aria-hidden', 'false');
            panel.style.transform = 'translateY(0)';
            const panelHeight = panel.scrollHeight;
            btn.style.bottom = (panelHeight + 20) + 'px';
          }
        });

        item.appendChild(panel);
        item.appendChild(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModelInfo);
  } else {
    initModelInfo();
  }
})();
